import React from 'react'
import './directAccessItem.scss'
import arrowIcon from '../../../assets/expand-arrow.svg'

type TDirectAccessItem = {
	icon: string,
	title: string,
	description: string,
	redirect: string,
}

const DirectAccessItem = (props: TDirectAccessItem) => {

	const { icon, title, description, redirect } = props

	return (
		<a href={redirect} rel="noreferrer" target={'_blank'} className="direct-access-item">
			<div className="direct-access-item__container">
				<img className="direct-access-item__icon" src={icon} alt={title} />
				<div className="direct-access-item__info">
					<h3>{title}</h3>
					<p>{description}</p>
				</div>
			</div>
			<img className='direct-access-item__arrow' src={arrowIcon} alt={title} />
		</a>
	)
}

export default DirectAccessItem